import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as User from '../../helpers/User';
import * as Common from '../../helpers/Common';
import {validateFile} from '../../helpers/Fields';
import * as Config from '../../config/Config';



import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getNewPost} from '../../actions/newPostAction';

const $=window.$;


class NewPost extends Component {

	 constructor(props) {


        super(props);

        this.state={
            newpost:[],
            count : 0,
            noticecount : 0,
        };

        this.redirectPage = this.redirectPage.bind(this);
        this.props.getNewPost();

    }


    componentWillReceiveProps(nextProps) {
      
      this.setState({
        newpost: nextProps.newPost.newposts,
        count: nextProps.newPost.count,
      });
     
    }

 
    redirectPage(type){
        const {Webview} = this.props;
        if(Webview!==undefined && Webview==='webview'){
           return false;
        }else{
          this.props.redirectprops(type);
        }
    }


    
	

	componentDidMount() {
	
	}

  render() {

    let newpost = null;
    let corporateID = Common.getUserData('corporateID', true);
     const {Webview} = this.props;
     

    if(this.state.newpost!=undefined || this.state.newpost!=null){
      
             if(Webview!==undefined && Webview==='webview'){
              let appcode = this.props.appcode;
              let device_id = this.props.device_id;
              let url_courseware    = "#/learning-resources/"+appcode+"/"+device_id+"/courseware";
              let url_poll          = "#/group-Interactions/"+appcode+"/"+device_id+"/opinionpolls";
              let url_library       = "#/learning-resources/"+appcode+"/"+device_id+"/library";
              let url_message       = "#/personal-interaction/"+appcode+"/"+device_id+"/messages";
              
              
              newpost = this.state.newpost.map((post,is)=>{
                    return( 
                    <ul key={`post_${is}`}>
                     {(post.blog)?<li ><span dangerouslySetInnerHTML={{__html: post.blog}}/></li>:''}
                     {(post.courseware)?<li ><a href={url_courseware} ><span dangerouslySetInnerHTML={{__html: post.courseware}}/></a></li>:''}
                     {(post.dlr)?<li ><span dangerouslySetInnerHTML={{__html: post.dlr}}/></li>:''}
                     {(post.forum)?<li ><span dangerouslySetInnerHTML={{__html: post.forum}}/></li>:''}
                     {(post.lr)?<li ><span dangerouslySetInnerHTML={{__html: post.lr}}/></li>:''}
                     {(post.library)?<li ><a href={url_library} ><span dangerouslySetInnerHTML={{__html: post.library}}/></a></li>:''}
                     {(post.message)?<li ><a href={url_message} ><span dangerouslySetInnerHTML={{__html: post.message}}/></a></li>:''}
                     {(post.poll)?<li ><a href={url_poll} ><span dangerouslySetInnerHTML={{__html: post.poll}}/></a></li>:''}
                   </ul>
                    )
                  });
              } else{


               newpost = this.state.newpost.map((post,is)=>{
                    return( 


                          <ul key={`post_${is}`}>
                           {(post.blog)?<li ><a href="javascript:void(0);" ><span dangerouslySetInnerHTML={{__html: post.blog}}/></a></li>:''}
                           {(post.courseware)?<li ><a href="javascript:void(0);" onClick={(e)=>this.redirectPage('courseware')}><span dangerouslySetInnerHTML={{__html: post.courseware}}/></a></li>:''}
                           {(post.dlr)?<li ><a href="javascript:void(0);" onClick={(e)=>this.redirectPage('componet_list')}><span dangerouslySetInnerHTML={{__html: post.dlr}}/></a></li>:''}
                           {(post.forum)?<li ><a href="javascript:void(0);" ><span dangerouslySetInnerHTML={{__html: post.forum}}/></a></li>:''}
                           {(post.lr)?<li ><a href="javascript:void(0);" onClick={(e)=>this.redirectPage('componet_list')}><span dangerouslySetInnerHTML={{__html: post.lr}}/></a></li>:''}
                           {(post.library)?<li ><a href="javascript:void(0);" onClick={(e)=>this.redirectPage('library')}><span dangerouslySetInnerHTML={{__html: post.library}}/></a></li>:''}
                           {(post.message)?<li ><a href="javascript:void(0);" onClick={(e)=>this.redirectPage('messages')}><span dangerouslySetInnerHTML={{__html: post.message}}/></a></li>:''}
                           {(post.poll)?<li ><a href="javascript:void(0);" onClick={(e)=>this.redirectPage('opinion_poll')}><span dangerouslySetInnerHTML={{__html: post.poll}}/></a></li>:''}
                          </ul>
                      )
                  });

              }
                    
               
    }


    return (
            <aside className="slide-out slide3">
                {(Webview===undefined && Webview!=='webview' && corporateID!=77) && <a className="handle" href="javascript:void(0);" id="newpost">New posts</a>}
                <h2><img src={'images/img1.jpg'} align="texttop" alt="" border="0"/> New posts</h2>
                {newpost}
               {(Webview===undefined && Webview!=='webview' && corporateID!=77) &&  (this.state.count>0)?<span className="badge-noticeboard" data-badge={this.state.count}></span>:''}
            </aside>
    );
  }
}
function mapStateToProps(state, ownProps) {      
  
  return {
    newPost: state.newPost
  };
}

function mapDispatchToProps(dispatch) {
      
  return  bindActionCreators({getNewPost}, dispatch);
 
}

export default connect(mapStateToProps,mapDispatchToProps)(NewPost);


// WEBPACK FOOTER //
// ./src/partials/qlink_partials/NewPost.js